import React, { useMemo, useState } from 'react';

import { createGenericContext } from '@app/common/contexts/createGenericContext';

import { findField } from '@app/widgets/contacts-and-settings/utils/subFieldsFinder';

import { useSettingFieldsContext } from './SettingFieldsContext';

export interface AddressFormData {
  readonly country: string;
  readonly isForeignAddressEnabled: boolean;
  readonly isApoFpoFeatureEnabled: boolean;
  readonly isApoFpoEnabled: boolean;
  readonly setIsApoFpoEnabled: (value: boolean) => void;
  readonly setCountry: (value: string) => void;
}

export const COUNTRY_FIELD_NAME = 'Country';
export const MILITARY_ADDRESS_FIELD_NAME = 'MilitaryMailingAddressGroup';

/**
 * Context to contacts & settings address form.
 */
const [useAddressFormContext, AddressFormContextProvider] = createGenericContext<AddressFormData>();

/**
 * Contacts & settings address form context provider.
 */
const SettingFieldsProvider: React.FC = ({ children }) => {
  const { fields } = useSettingFieldsContext();
  const [country, setCountry] = useState('');

  const isForeignAddressEnabled = useMemo(() => !!findField(
    fields,
    (entity) => (entity.id === COUNTRY_FIELD_NAME ? entity : null),
  ), [fields]);

  const isApoFpoFeatureEnabled = useMemo(() => !!findField(
    fields,
    (entity) => (entity.id === MILITARY_ADDRESS_FIELD_NAME ? entity : null),
  ), [fields]);

  const [isApoFpoEnabled, setIsApoFpoEnabled] = useState(isApoFpoFeatureEnabled);

  return (
    <AddressFormContextProvider
      value={{
        country,
        isForeignAddressEnabled,
        isApoFpoFeatureEnabled,
        isApoFpoEnabled,
        setIsApoFpoEnabled,
        setCountry,
      }}
    >
      {children}
    </AddressFormContextProvider>
  );
};

export { useAddressFormContext, SettingFieldsProvider };
